import { RxAuthAPI } from '@drifthq/dapper'

export const api = {
  regenerateCode() {
    return RxAuthAPI
      .post('/authenticate/code/regenerate')
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
}



// WEBPACK FOOTER //
// ./src/modules/auth/api.js